<template>
  <Vue3StarRating
    v-model="rating"
    :numberOfStars="5"
    :starSize="39"
    :starColor="'#606266'"
    :inactiveColor="'#E9E9EB'"
    :disableClick="false"
    :customSvg="StarRounded"
  />
</template>

<script setup lang="ts">
import Vue3StarRating from "vue3-star-ratings";
import StarRounded from "@/widgets/MarketplaceReviews/Icons/StarRounded.vue";
import { ref, watch } from "vue";

/* NOTE:
  This component uses only for correct working `StarRounded` component as prop.
  Options-API in ImageUpload.vue cannot set component as prop into another component
*/

const props = withDefaults(
  defineProps<{
    modelValue?: number;
  }>(),
  {
    modelValue: () => {
      return 0;
    },
  }
);

const emit = defineEmits<{
  "update:modelValue": [option: number];
}>();

const rating = ref<number>(props.modelValue);
function setRating(option: number) {
  emit("update:modelValue", option);

  rating.value = option;
}

watch(
  () => props.modelValue,
  (value) => {
    rating.value = value;
  }
);

watch(rating, (value) => {
  setRating(Math.ceil(value));
});
</script>

<style lang="scss">
.vue3-star-ratings {
  width: fit-content;
  height: 37px;

  svg:not(:last-child) {
    margin-right: 5px;
  }
}
</style>
